export default __webpack_public_path__ + "static/media/portis.f44aba13.png";